<template>
  <div class="d-flex align-items-start border-color--gray-17 rounded p-3">
    <div class="mr-2">
      <b-form-radio
        v-model="value"
        :name="name"
        :value="rbValue"
        :disabled="disabled"
        @change="$emit('input', rbValue)"
      />
    </div>
    <div class="row flex-grow-1">
      <div class="col-md-9">
        <span class="d-block color-black-2 font-14 font-weight-bold">
          {{ mainText }}
        </span>
        <span v-if="subText" class="color-gray-18 font-12">
          {{ subText }}
        </span>
      </div>
      <div
        v-if="!hideValidityInfo"
        class="col-md-3 d-flex justify-content-end align-items-center"
      >
        <div>
          <div class="color-black-2 font-10 font-weight-bold">
            {{ $t('ValidityTime') }}:
          </div>
          <span class="color-gray-18 font-12 font-weight-bold">
            {{ validityText }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomRadioText',
  data: () => ({
    modelValue: null,
  }),
  props: {
    name: {
      type: String,
      default: 'rb',
    },
    rbValue: {
      type: [String, Number, Boolean],
    },
    value: {
      type: Number,
      default: 0,
    },
    mainText: {
      type: String,
      default: '',
    },
    subText: {
      type: String,
      default: '',
    },
    validityText: {
      type: String,
      default: '',
    },
    hideValidityInfo: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
